/**
 * @voltxampere/ui — JTAG 10-pin header variant (Sprint 49-7)
 *
 * 10-pin 0.05" pitch header per Atmel ICE / SAM-ICE convention.
 * Pinout:
 *   1 TCK   2 GND
 *   3 TDO   4 VCC
 *   5 TMS   6 nSRST
 *   7 (NC)  8 nTRST
 *   9 TDI  10 GND
 *
 * Reference: Atmel ICE User Guide (40001925A, 2014).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const connectorJtagHeader = {
    id: "jtag-header",
    nameTr: "JTAG Header (10-pin Atmel ICE)",
    nameEn: "JTAG Header (10-pin Atmel ICE)",
    shortcut: "J",
    category: "connector",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "J",
    defaultValue: "JTAG",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        busType: "jtag-header",
        pinCount: 10,
        pitchInch: 0.05,
        pinout: {
            "1": "TCK",
            "2": "GND",
            "3": "TDO",
            "4": "VCC",
            "5": "TMS",
            "6": "nSRST",
            "7": "NC",
            "8": "nTRST",
            "9": "TDI",
            "10": "GND",
        },
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=connector-jtag-header.js.map